import {getFactionConfig} from './getFactionConfig';
import {getFactionImagePath} from './getFactionImagePath';
import {getFactionSkinDisplayProps} from './getFactionSkinDisplayProps';

/**
 * Полный арт фракции в образе — как в карточке фракции (FactionCardOverlay) и
 * над списком игроков в лобби. Одна формула на оба места: лобби грузит эти
 * адреса заранее, и карточка должна открывать ровно их.
 *
 * Образ по умолчанию, неизвестный образ и фракция без конфига — базовый арт.
 *
 * @param {string} factionId
 * @param {string} [skinId]
 * @returns {string}
 */
export const getFactionSkinArtPath = (factionId, skinId) => {
  const config = getFactionConfig(factionId);
  if (!config) {
    return getFactionImagePath(factionId);
  }
  return getFactionSkinDisplayProps(config, skinId).imagePath || getFactionImagePath(factionId);
};
